<template>
	<v-row justify="center" class="align-content-center ">
		<v-col cols="12" md="5">
			<v-card>
				<v-card-title class="justify-center">
					<v-img max-width="200" src="/img/cadnet.jpeg"></v-img>
				</v-card-title>
				<v-card-title class="justify-center">
					<h3>הזמנתך התקבלה בהצלחה</h3>
					<h2>
						<span>תודה שבחרת ב</span>
						<strong>קאדנט מדידות ממוחשבות </strong>
					</h2>
				</v-card-title>
				<v-card-text class="justify-center text-center">
					<h3 class="text-center">אנא העלה אישור תשלום</h3>
					<v-row justify="center">
						<v-col v-if="!complete" cols="12" md="8">
							<form ref="form" @submit.prevent="uploadFile">
								<v-file-input
									name="payment"
									truncate-length="15"
									placeholder="לחץ ובחר את הקובץ המתאים"
								></v-file-input>
								<btn-loader :progress="progress">שליחה</btn-loader>
							</form>
						</v-col>
						<v-col v-else cols="12" md="8">
							<h1 class="text-center">תודה! נחזור אליך בהקדם.</h1>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
	import BtnLoader from "dev/components/BtnLoader";
	import {types} from "dev/store/modules/OutsideModule";
	export default {
		name: "thank-view",
		components: {BtnLoader},
		data(){
			return {
				progress:false,
				complete:false,
			};
		},
		methods:{
			async uploadFile(){
				this.progress = true;

				const formData = new FormData(this.$refs.form);
				try {
					await this.$store.dispatch(types.PAYMENT, {uuid: this.$route.params.uuid, form: formData});
					this.complete = true;
				} catch (e) {
				}
				this.progress = false;

			}
		}
	};
</script>

<style scoped>

</style>
